import { CanDeactivateFn } from '@angular/router';
import { TestCaseFormComponent } from './test-case-form.component';

export const canDeactivateTestCaseForm: CanDeactivateFn<TestCaseFormComponent> = (component) => {
  if (component.form.dirty && !component.saving()) {
    return component.confirmDeactivate();
  }
  return true;
};
